module.exports = __webpack_public_path__ + "static/media/discount-tag-white.92ca8ed1.svg";